/**
 * JmPayPresenter
 * --
 */
import React, { useRef, useState, useEffect } from 'react';
import { Content, Row, Col, ModalLayout, Title } from 'components';
import { Spin, Tabs } from 'antd';
import Summary from './components/Summary';
import UserList from './components/UserList';
import ChargingHistory from './components/ChargingHistory';
import RefundList from './components/RefundList';
import RefundApplication from './components/RefundApplication';
import JmPayFilter from './components/JmPayFilter';

/**----------------------------------------
 * [Component] 매출관리 > 제이엠페이 - 프레젠터
 * ----------------------------------------
 */
const JmPayPresenter = ({
  userList,
  jmpayList,
  refundList,
  currentTab,
  setCurrentTab,
  isLoading,
  startDate,
  endDate,
  currentRow,
  onSearch,
  onSelect,
  setCurrentRow,
  onSaveAnswer,
  onIssue,
  cashBillInfo,
  setCashBillInfo,
  initialValue,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // 프로퍼티
  const p = {
    // data: userList,
    currentRow,
    startDate,
    endDate,
    onSelect,
    userList,
    setCurrentRow,
    onIssue,
    cashBillInfo,
    setCashBillInfo,
    initialValue,
  };

  /* ===== FUNCTION ===== */

  /* ===== RENDER ===== */
  // console.log('userList: ', userList);
  // console.log('jmpayList: ', jmpayList);
  // console.log('refundList: ', refundList);

  const totalCount = userList ? userList.length : 0;
  const totalAmount = userList
    ? userList.reduce((acc, cur) => acc + cur.jm_pay, 0)
    : 0;
  const totalPrice = jmpayList
    .filter((item) => item.type === 'USE')
    .reduce((acc, cur) => acc + Math.abs(cur.price), 0);
  const totalCharge = jmpayList
    .filter(
      (item) =>
        item.type === 'MANUAL_CHARGE' ||
        item.type === 'AUTO_CHARGE' ||
        item.type === 'OVER_CHARGE'
    )
    .reduce((acc, cur) => acc + cur.price, 0);
  const totalRefundPrice = jmpayList
    .filter((item) => item.type === 'CANCELLED' || item.type === 'REFUNDED')
    .reduce((acc, cur) => acc + cur.price, 0);

  // JSX: start
  return (
    <>
      <Spin spinning={isLoading}>
        <Row>
          {/* ===== Right: 차트 ===== */}
          <Col x={24}>
            <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
              <Title size={3} style={{ marginBottom: '13px' }}>
                JM페이
              </Title>
              {/* ===== 필터 ===== */}
              <JmPayFilter onReset={onSearch} onSearch={onSearch} />
              <br />
              <br />
              <Summary
                totalCount={totalCount}
                totalAmount={totalAmount}
                totalPrice={totalPrice}
                totalCharge={totalCharge}
                totalRefundPrice={totalRefundPrice}
              />
              <br />
              <br />
              {/* ===== 필터 ===== */}
              <Tabs
                type="card"
                size={'large'}
                defaultActiveKey="1"
                onChange={setCurrentTab}
                style={{
                  padding: 0,
                }}
                items={[
                  {
                    label: `JM페이 유저`,
                    key: 'user-list',
                  },
                  {
                    label: `전체내역`,
                    key: 'history',
                  },
                  {
                    label: `충전내역`,
                    key: 'charge',
                  },
                  {
                    label: `결제취소내역`,
                    key: 'cancel',
                  },
                  {
                    label: `결제환불완료`,
                    key: 'refund',
                  },
                  {
                    label: `잔액환불신청`,
                    key: 'refund_application',
                  },
                ]}
              />
              <Content
                maxWidth={'100%'}
                padding={20}
                backgroundColor={'#fff'}
                style={{ marginTop: -16 }}
              >
                {/* ===== 페이지 ===== */}
                {currentTab === 'user-list' && (
                  <UserList data={userList} {...p} />
                )}
                {currentTab === 'history' && (
                  <ChargingHistory
                    data={jmpayList}
                    {...p}
                    currentTab={currentTab}
                  />
                )}
                {currentTab === 'charge' && (
                  <ChargingHistory
                    data={jmpayList.filter(
                      (item) =>
                        item.type === 'MANUAL_CHARGE' ||
                        item.type === 'AUTO_CHARGE' ||
                        item.type === 'OVER_CHARGE'
                    )}
                    {...p}
                    currentTab={currentTab}
                  />
                )}
                {currentTab === 'cancel' && (
                  <ChargingHistory
                    data={jmpayList.filter((item) => item.type === 'CANCELLED')}
                    {...p}
                    currentTab={currentTab}
                  />
                )}
                {currentTab === 'refund' && (
                  <ChargingHistory
                    data={jmpayList.filter((item) => item.type === 'REFUNDED')}
                    {...p}
                    currentTab={currentTab}
                  />
                )}
                {currentTab === 'refund_application' && (
                  <RefundApplication
                    data={refundList}
                    {...p}
                    onSaveAnswer={onSaveAnswer}
                  />
                )}
              </Content>
            </Content>
          </Col>
          {/* ===== Right: 차트 ===== */}
        </Row>
      </Spin>

      {/* ===== 상세모달 ===== */}
      {/* <ModalLayout
        type="drawer"
        maxWidth={1140}
        isOpen={currentRow !== null}
        open={currentRow !== null}
        title="주문상세내역"
        closable={true}
        onCancel={() => onSelect(null)}
      >
        <Spin spinning={isLoading}>
          <StatisticsRawData headerData={currentRow} data={rawData} />
        </Spin>
      </ModalLayout> */}
    </>
  ); // JSX: end
};

/* ===== DF ===== */
JmPayPresenter.defaultProps = {
  isLoading: false,
  userList: {},
  orderList: [],
  todayOrderList: [],
  orderListRaw: [],
  chartData: {
    menuSales: [],
    weeklyData: [],
  },

  onDownloadExel: () => {},
};
export default JmPayPresenter;
